import React from 'react';
import styles from '../styles/components/_InfosPratiques.module.scss';
import FlightInfo from './bento/FlightInfo';
import Billetterie from './Billetterie';
import FoodTeaser from './FoodTeaser';
import MerchandiseGrid from './MerchandiseGrid';
import LocationParking from './bento/LocationParking';
import PublicTransport from './bento/PublicTransport';
import NewsletterForm from '../components/NewsletterForm';

const InfosPratiques = () => {
  return (
    <>
    
    <MerchandiseGrid />

    <FoodTeaser/>

    <Billetterie />

    <NewsletterForm />
     
    </>
   
  );
};

export default InfosPratiques;